module.exports = __webpack_public_path__ + "static/media/shocks-shocks-red.50e3d76b.svg";